import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@marvelapp/marvel-ui/heading';

import styles from './th.module.css';

export default function th({ children }) {
  return (
    <th className={styles.th}>
      <Heading tag="div" size="m" color="black" weight="semibold">
        {children}
      </Heading>
    </th>
  );
}

th.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/markdown/th.js